import React, { useState, useEffect } from "react";

/* ---------- css ---------- */
import "bootstrap/dist/css/bootstrap.css";
import "./Footer.css";

/* ---------- images ---------- */
// import cubeLogo from "../../resources/3d-cube.svg";
import cloudSurfLogo from "../../resources/logos/cloud-logo-black.svg";

function Footer(props) {
  return (
    <React.Fragment>
      <div className="footer-container">
        <div className="footer-wrapper">
          {/* <img src={cloudSurfLogo} className="footer-company-icon"></img> */}
          {/* <p className="footer-company-name">CloudSurf Software</p> */}

          <div className="footer-icons">
            <a href="https://www.facebook.com/ACEFitnessLV/" target="_blank">
              <i className="fa fa-facebook footer-icon"></i>
            </a>
            <a
              href="https://twitter.com/ACEFitnessLV?fbclid=IwAR1dYveSjwE0hZULBlPQrbpcwxpBKs0JpdEsh6ZZsmb9Mo6A_IPp2gOA6uc"
              target="_blank"
            >
              <i className="fa fa-twitter footer-icon"></i>
            </a>
            <a
              href="https://www.instagram.com/ACEFitnessLV/?fbclid=IwAR3Li1dg0h3G_COX9gMmLxxwWg5rRmFbdDHql37pWwIHY4u4VPtB3KBqUYE"
              target="_blank"
            >
              <i className="fa fa-instagram footer-icon"></i>
            </a>
          </div>
          {/* footer-icons */}
          <p className="footer-text">&copy; 2021 FITEX</p>
          <p className="footer-text">
            Powered by{" "}
            <a
              href="https://cloudsurfsoftware.com/"
              target="_blank"
              className="cloudsurf-text"
            >
              Cloudsurf
            </a>{" "}
          </p>
        </div>
        {/* footer-wrapper */}
      </div>
      {/* footer-container */}
    </React.Fragment>
  );
}

export default Footer;
